//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        gstPrice: [],
        searchRequest: null,
      },

      mutations: {
        updateGSTPrice(state, list) {
          state.gstPrice = list;
        },
        updateSearchGSTPriceRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async gstPrice({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))
          console.log(requestToSend);

          const validDate = requestToSend.validOn;
          requestToSend.validOn = dateFormat.gstDateFormat(validDate);
            const st = performance.now();
            //const result = await api.post('/api/w/gst/gstpriceagreement/search', requestToSend);
            const result = await newAPIPost('/api/w/gst/gstpriceagreement/search', requestToSend);
            commit('updateSearchGSTPriceRequest', fallbackRequest);
            console.log(JSON.stringify(result));
            return commit('updateGSTPrice', result);
            
                },
      },


      getters: {
        getGSTPrice: state => state.gstPrice,
      },
}